// P2b tanda 6 (parte 0) — MODO HÍBRIDO de guías: cuando las guías viven en
// OTRO WordPress que el catálogo, los term_id no coinciden entre tiendas. El
// editor NUNCA envía los ids del catálogo: traduce cada categoría marcada
// contra las categorías del WordPress de guías, por SLUG primero y por NOMBRE
// si el slug no coincide (sin tildes ni mayúsculas). Las que no encuentran
// equivalente se declaran (aviso "No existen en el WordPress de guías: …") y
// NO se envían — sin bloquear el guardado de las demás.

function llano(s) {
  return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}

// idsMarcados: term_ids de la tienda del CATÁLOGO.
// catalogoCategorias: [{id, name, slug?}] del catálogo.
// guiasCategorias: [{id, name, slug}] del WordPress de guías.
// → { ids: [term_ids del WordPress de guías], sinEquivalente: [nombres] }
export function traducirCategorias(idsMarcados, catalogoCategorias, guiasCategorias) {
  const porId = new Map((catalogoCategorias || []).map((c) => [c.id, c]));
  const porSlug = new Map();
  const porNombre = new Map();
  for (const g of guiasCategorias || []) {
    if (g.slug) porSlug.set(llano(g.slug), g.id);
    if (g.name) porNombre.set(llano(g.name), g.id);
  }
  const ids = [];
  const sinEquivalente = [];
  for (const id of idsMarcados || []) {
    const cat = porId.get(id);
    if (!cat) { sinEquivalente.push(`#${id}`); continue; }
    const porElSlug = cat.slug ? porSlug.get(llano(cat.slug)) : undefined;
    const destino = porElSlug !== undefined ? porElSlug : porNombre.get(llano(cat.name));
    if (destino !== undefined) ids.push(destino);
    else sinEquivalente.push(cat.name);
  }
  return { ids, sinEquivalente };
}
